import { Tables } from './database.types';

// Base menu item type from database
export type MenuItem = Tables<'menu_items'>;

// Link type enum for type safety
export enum MenuItemLinkType {
  INTERNAL = 'internal',
  CUSTOM = 'custom',
}

// Menu item with children for hierarchical structure
export interface MenuItemWithChildren extends Omit<MenuItem, 'parent_id'> {
  children?: MenuItemWithChildren[];
}

// DTOs for API operations
export interface CreateMenuItemDto {
  festival_id: string;
  parent_id?: string;
  title: {
    en: string;
    fr: string;
  };
  link_type: MenuItemLinkType;
  internal_page?: string;
  custom_url?: string;
  open_in_new_tab?: boolean;
  order_index: number;
  is_published?: boolean;
}

export interface UpdateMenuItemDto {
  parent_id?: string | null;
  title?: {
    en: string;
    fr: string;
  };
  link_type?: MenuItemLinkType;
  internal_page?: string | null;
  custom_url?: string | null;
  open_in_new_tab?: boolean;
  order_index?: number;
  is_published?: boolean;
}

// Frontend menu item structure (matches current asideLinks format)
export interface FrontendMenuItem {
  title: string;
  link?: string;
  openInNewTab?: boolean;
  items: FrontendMenuItemChild[];
}

export interface FrontendMenuItemChild {
  title: string;
  link: string;
  openInNewTab?: boolean;
}

// Menu loading states
export interface MenuState {
  items: FrontendMenuItem[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

// Available internal pages (from PathEnum)
export const INTERNAL_PAGES = [
  { value: '/', label: 'Home' },
  { value: '/films/', label: 'Films' },
  { value: '/short-programmes', label: 'Short Programmes' },
  { value: '/get-involved/', label: 'Get Involved' },
  { value: '/checkout/', label: 'Checkout' },
  { value: '/tickets/', label: 'Tickets' },
  { value: '/partners/', label: 'Partners' },
  { value: '/profile/accreditation/', label: 'Profile Accreditation' },
  { value: '/sign-up/', label: 'Sign Up' },
  { value: '/sign-in/', label: 'Sign In' },
  { value: '/tickets-and-venues/', label: 'Tickets and Venues' },
  { value: '/program/', label: 'Program' },
  { value: '/account/', label: 'Account' },
  { value: '/account/my-tickets/', label: 'My Tickets' },
  { value: '/account/order-history/', label: 'Order History' },
  { value: '/account/travel-info/', label: 'Travel Info' },
  { value: '/account/accreditation/', label: 'Accreditation' },
  { value: '/404/', label: '404' },
  { value: '/schedule/', label: 'Schedule' },
  { value: '/interactive-catalogue/', label: 'Interactive Catalogue' },
  { value: '/forgot-password/', label: 'Forgot Password' },
  { value: '/connexe/', label: 'Connexe' },
  { value: '/insights/', label: 'Insights' },
  { value: '/about/', label: 'About' },
  { value: '/awards/', label: 'Awards' },
  { value: '/jury/', label: 'Jury' },
] as const;
